import React from 'react';

import { LegacyText, LegacyBox, MarkdownRender } from '@gogame/components';
import { DateValueFormatter } from '@gogame/intl-ts';

const Preview = ({
  title,
  text,
  icon,
  date = new Date(),
  dateTemplate = 'LLL',
}) => {
  return (
    <LegacyBox style={{ padding: '0 8px' }} vertical={true}>
      <LegacyBox align={'center'}>
        <LegacyBox>
          {React.cloneElement(icon, {
            color: 'action',
            style: { margin: '8px' },
          })}
        </LegacyBox>
        <LegacyBox vertical={true} style={{ padding: '8px' }}>
          <LegacyBox>
            <LegacyText>{title}</LegacyText>
          </LegacyBox>
          <LegacyBox>
            <LegacyText>
              <DateValueFormatter
                value={date}
                template={dateTemplate}
                timeZone={'local'}
              />
            </LegacyText>
          </LegacyBox>
        </LegacyBox>
      </LegacyBox>
      <LegacyBox style={{ paddingLeft: '52px' }}>
        <MarkdownRender value={text} />
      </LegacyBox>
    </LegacyBox>
  );
};

export default Preview;
